<template>
	<div class="app-container">
		<el-form v-model="form" :inline="true" ref="filtrateForm" size="mini">
			<el-form-item label="变动时间:" style="float:left;">
				<el-row>
					<el-col :span="18">
						<el-date-picker
							v-model="selectedTime"
							type="daterange"
							align="right"
							unlink-panels
							format="yyyy-MM-dd"
							range-separator="~"
							start-placeholder="开始时间"
							end-placeholder="结束时间"
							:default-time="['00:00:00', '23:59:59']"
							:picker-options="timeOptions"
						></el-date-picker>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item label="渠道名称:" style="float:left;">
				<el-autocomplete
					popper-class="my-autocomplete"
					v-model="supplierName"
					:fetch-suggestions="querySearch"
					placeholder="请输入渠道名称搜索"
					@select="handleSelect1"
				>
					<template slot-scope="{ item }">
						<div class="name">{{ item.access_name }}</div>
					</template>
				</el-autocomplete>
			</el-form-item>
			<el-form-item label="相关订单:" style="float:left;">
				<el-input
					size="mini"
					v-model="form.order_no"
					style="width:160px;"
					placeholder="输入供应链订单号"
				>
				</el-input>
			</el-form-item>
			<el-form-item style="float:left;">
				<el-button type="primary" @click="pageChange(1)">查询</el-button>
				<el-button @click="resetForm('filtrateForm')">重置</el-button>
				<!-- <el-button type="warning" @click="exportOrderData">导出</el-button> -->
			</el-form-item>
		</el-form>

		<el-table
			:data="recordList"
			max-height="600"
			size="mini"
			style="width: 100%"
			:cell-style="tc"
			:header-cell-style="tccolor"
			ref="table"
			v-loading="loading"
		>
			<el-table-column label="扣款单号" prop="id"></el-table-column>
			<el-table-column label="渠道名称" prop="access_name"></el-table-column>
			<el-table-column label="类型" prop="source_from_name"></el-table-column>
			<el-table-column label="变动时间" prop="created_at"></el-table-column>
			<el-table-column label="变动金额" prop="money"></el-table-column>
			<el-table-column
				label="供应链扣款订单号"
				prop="order_no"
			></el-table-column>
			<el-table-column label="操作" fixed="right" width="160">
				<template slot-scope="scope">
					<el-button
						type="warning"
						size="mini"
						@click="gotoOrderDetail(scope.row.id)"
						>查看原订单</el-button
					>
				</template>
			</el-table-column>
		</el-table>

		<div class="pagination">
			<el-pagination
				background
				@size-change="handleSizeChange"
				@current-change="pageChange"
				:current-page="form.page"
				:page-sizes="[20, 50, 100]"
				:page-size="form.page_size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			>
			</el-pagination>
		</div>
	</div>
</template>
<script>
import { recordList, getClient } from '@/api/channel'
import { parseTime } from '@/utils/index'
// import { BASE_API } from '@/config'
export default {
	data() {
		return {
			loading: false,
			form: {
				page: 1,
				page_size: 20,
				change_type: 0,
				app_id: '',
				created_at_gt: '',
				created_at_lt: '',
				order_no: ''
			},
			supplierName: '',
			selectedTime: '',
			timeOptions: {
				shortcuts: [
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近15天',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(new Date().setMonth(new Date().getMonth() - 1))
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			//来源数据
			recordList: [],
			//供应商数据
			supplierList: [],
			tableData: [],
			total: 0,
			quantity_num: 0
		}
	},

	activated() {
		this.getSuppliersFn()
	},
	methods: {
		querySearch(queryString, cb) {
			var restaurants = this.supplierList
			console.log(restaurants, 111)
			var results = queryString
				? restaurants.filter(this.createFilter(queryString))
				: restaurants
			// 调用 callback 返回建议列表的数据
			cb(results)
		},
		createFilter(queryString) {
			console.log(queryString)
			return supplierList => {
				return (
					supplierList.access_name
						.toLowerCase()
						.indexOf(queryString.toLowerCase()) === 0
				)
			}
		},
		handleSelect1(item) {
			console.log(item)
			this.form.app_id = item.app_id
			this.supplierName = item.access_name
		},

		pageChange(page) {
			this.form.page = page
			this.getList(this.form)
		},
		selectOrderType(id) {
			if (id == 1) {
				this.form.order_no = ''
			} else {
				this.form.out_order_no = ''
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields()
			this.selectedTime = ''
			// this.deliveryTime = ''
			this.form = {
				page: this.form.page,
				page_size: this.form.page_size,
				change_type: 0,
				appid: '',
				created_at_gt: '',
				created_at_lt: '',
				order_no: ''
			}
		},
		//查看详情
		gotoOrderDetail(id) {
			this.$router.push({
				path: '/orders/detail',
				query: {
					orderId: id
				}
			})
		},

		handleSizeChange(val) {
			this.form.page_size = val
			this.pageChange(1)
		},

		async getList() {
			const form = this.form
			if (this.selectedTime === null) {
				this.selectedTime = ''
			}
			if (this.selectedTime !== '') {
				form.created_at_gt = parseTime(
					this.selectedTime[0],
					'yyyy-MM-dd hh:mm:ss'
				)
				form.created_at_lt = parseTime(
					this.selectedTime[1],
					'yyyy-MM-dd hh:mm:ss'
				)
			} else {
				form.created_at_gt = ''
				form.created_at_lt = ''
			}
			let res = await recordList(this.form)
			this.recordList = res.data
			this.total = res.total
			this.quantity_num = res.quantity_num
		},

		async exportOrderData() {
			// let res = await exportOrderList(this.form)
			// if (res.code === 2) {
			// 	this.loading = true
			// 	console.log(res)
			// 	this.form.page = res.page
			// 	this.form.filename = res.filename
			// 	this.form.last_id = res.last_id
			// 	this.exportOrderData()
			// } else if (res.code === 1) {
			// 	this.loading = false
			// 	window.open(`${BASE_API}/admin/download/zip/${res.download_token}`)
			// } else {
			// 	this.loading = false
			// 	this.$message.error(res.message)
			// }
		},

		//获取渠道商来源
		async getSuppliersFn() {
			try {
				let res = await getClient()
				this.supplierList = res
				this.getList(this.form)
			} catch (e) {
				console.log(e)
			}
		},
		tc() {
			return 'text-align:center;'
		},
		tccolor() {
			return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
		}
	}
}
</script>
<style lang="scss" scoped>
.el-form {
	display: flex;
	flex-wrap: wrap;
}
.app-container {
	padding: 20px;
	background-color: #fff;
}
//已完成
.account_status_wancheng {
	color: #67c23a;
}
//已关闭
.account_status_guanbi {
	color: #f4222d;
}
//待支付
.account_status_zhifu {
	color: rgb(191, 191, 191);
}
//待发货
.account_status_fahuo {
	color: rgb(253, 190, 44);
}
//待收获
.account_status_shouhuo {
	color: rgb(26, 121, 206);
}
.pagination {
	float: right;
	margin-top: 20px;
}
.info {
	text-align: left;
	font-size: 14px;
	font-weight: bold;
	padding: 10px 0;
}
</style>
